import { render, staticRenderFns } from "./advertisingSpaceManagement.vue?vue&type=template&id=2732d770&"
import script from "./advertisingSpaceManagement.vue?vue&type=script&lang=js&"
export * from "./advertisingSpaceManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2732d770')) {
      api.createRecord('2732d770', component.options)
    } else {
      api.reload('2732d770', component.options)
    }
    module.hot.accept("./advertisingSpaceManagement.vue?vue&type=template&id=2732d770&", function () {
      api.rerender('2732d770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/advertisingSpaceManagement.vue"
export default component.exports